// extracted by mini-css-extract-plugin
export var compactFilters = "_de-4";
export var detailImage = "_de-1";
export var dropdownContainer = "_de-2";
export var imageContainer = "_de-0";
export var selectedCard = "_de-3";